import { NgModule } from '@angular/core';
import { ArquiteturaModule } from 'src/app/arquitetura/arquitetura.module';
import { ExcluirContaPage } from './excluir-conta.page';

@NgModule({
  declarations: [
    ExcluirContaPage
  ],
  imports: [
    ArquiteturaModule
  ]
})
export class ExcluirContaModule { }
